import gql from 'graphql-tag';

export default gql`
  mutation CreateEvent(
    $name: String!
    $type: EventType
    $host: String!
    $location: String!
    $startDate: DateTime!
    $accessStartDate: DateTime
    $accessEndDate: DateTime
    $endDate: DateTime!
    $description: String!
    $hostLogo: String
    $status: EventStatus
    $reminders: Boolean
  ) {
    createEvent(
      data: {
        name: $name
        type: $type
        host: $host
        location: $location
        startDate: $startDate
        accessStartDate: $accessStartDate
        accessEndDate: $accessEndDate
        endDate: $endDate
        description: $description
        hostLogo: $hostLogo
        status: $status
        reminders: $reminders
      }
    ) {
      id
      createdAt
      updatedAt
      name
      type
      host
      location
      startDate
      accessStartDate
      accessEndDate
      endDate
      description
      hostLogo
      links
      status
      children
      reminders
      attendees {
        id
        cellNumber
        email
      }
      image {
        id
        original
        scaled
        thumbnail
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateEvent.ts